
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"219","height":"54","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#FFB0E2"}},[_c('path',{attrs:{"d":"M42.8 0h12.5l-11 53.1H32.1l-4.5-24.4-4.7 24.4H11.1L0 0h13.8l4.8 29.8L23.4 0h9.7l4.7 29.8 5-29.8zM84.5 0h14.2v53.1H84.5V33.6h-8.4v19.5H61.9V0h14.2v21.5h8.4V0zM151.6.4l14.2.1v41H181v12h-29.5l.1-53.1zM187.9 0h30.2v11.6h-16v9.3h10.4v10h-10.4v9.9h16v12.3h-30.2V0zM121.5 26.2l4.1-4.1 4.1 4.1-4.1 4.1-4.1-4.1zm4.1-10.7L115 26.2l10.7 10.7 10.7-10.7-10.8-10.7z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h218.1v53.5H0z"}})])])])
          )
        }
      }
    